import { render, staticRenderFns } from "./calc.vue?vue&type=template&id=28b2f4a7&scoped=true"
import script from "./calc.vue?vue&type=script&lang=js"
export * from "./calc.vue?vue&type=script&lang=js"
import style0 from "./calc.vue?vue&type=style&index=0&id=28b2f4a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2f4a7",
  null
  
)

export default component.exports